import {
  Box,
  Container,
  Flex,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Nft, NftWithToken, Sft, SftWithToken } from "@metaplex-foundation/js";

import CardItem, {
  CardItemSkeleton,
  EmptyItems,
  NftCardItem,
} from "components/global/card-item";
import { Dispatch, SetStateAction, useState } from "react";
import { Item } from "src/API";
import { useParameterStore } from "utils/context";

export function ItemCollection({
  loaded,
  data = [],
  enableSelectItem = false,
  selectedItems,
  selectItemHandler,
  connectionUrl,
  showCheckBox,
}: {
  loaded?: boolean;
  data?: Item[];
  enableSelectItem?: boolean;
  selectedItems?: Item[];
  selectItemHandler?: Dispatch<SetStateAction<Item[]>>;
  connectionUrl?: string | null;
  showCheckBox?: boolean;
}) {
  const [detectMouse, setDetectMouse] = useState(false);
  const { idrBalance, gridSize } = useParameterStore();

  return (
    <Container maxW={"container.2xl"}>
      <SimpleGrid
        templateColumns={{
          base:
            gridSize == "medium"
              ? "repeat(auto-fill,minmax(200px,1fr))"
              : "repeat(auto-fill,minmax(120px,1fr))",
          md:
            gridSize == "medium"
              ? "repeat(auto-fill,minmax(240px,1fr))"
              : "repeat(auto-fill,minmax(180px,1fr))",
        }}
        spacing={5}
        onMouseEnter={() => setDetectMouse(true)}
        onMouseLeave={() => setDetectMouse(false)}
      >
        {data.length > 0
          ? data.map((props, index) => (
              <CardItem
                key={index}
                items={props}
                size={gridSize}
                enableSelectItem={enableSelectItem}
                selectedItems={selectedItems}
                selectItemHandler={selectItemHandler}
                showCheckBox={showCheckBox}
                boxStyle={{
                  filter: enableSelectItem
                    ? selectedItems && selectedItems.length != 0
                      ? selectedItems?.filter((f) => f.id == props.id).length >
                        0
                        ? "brightness(100%)"
                        : "brightness(50%)"
                      : showCheckBox
                      ? "brightness(50%)"
                      : detectMouse
                      ? "brightness(50%)"
                      : "brightness(100%)"
                    : "",
                }}
                solToIdrPrice={idrBalance}
                connectionUrl={connectionUrl}
              />
            ))
          : null}
        {!loaded
          ? [...Array(gridSize == "small" ? 14 : 10)].map((i, x) => (
              <CardItemSkeleton key={x} size={gridSize} />
            ))
          : null}
      </SimpleGrid>
      {data.length == 0 && loaded && <EmptyItems />}
    </Container>
  );
}

export function NftItemCollection({
  gridSize,
  loaded,
  data = [],
  enableSelectItem = false,
  selectedItems,
  selectItemHandler,
}: {
  loaded?: boolean;
  gridSize: "small" | "medium";
  data?: Array<Nft | Sft | NftWithToken | SftWithToken>;
  enableSelectItem?: boolean;
  selectedItems?: string[];
  selectItemHandler?: Dispatch<SetStateAction<string[]>>;
}) {
  const [detectMouse, setDetectMouse] = useState(false);

  return (
    <Container maxW={"container.2xl"}>
      <SimpleGrid
        templateColumns={{
          base:
            gridSize == "medium"
              ? "repeat(auto-fill,minmax(200px,1fr))"
              : "repeat(auto-fill,minmax(120px,1fr))",
          md:
            gridSize == "medium"
              ? "repeat(auto-fill,minmax(240px,1fr))"
              : "repeat(auto-fill,minmax(180px,1fr))",
        }}
        spacing={5}
        onMouseEnter={() => setDetectMouse(true)}
        onMouseLeave={() => setDetectMouse(false)}
      >
        {data.length > 0 &&
          data.map((props, id) => (
            <NftCardItem
              key={id}
              items={props}
              size={gridSize}
              enableSelectItem={enableSelectItem}
              selectItemHandler={selectItemHandler}
              boxStyle={{
                filter: enableSelectItem
                  ? selectedItems && selectedItems.length != 0
                    ? selectedItems?.filter(
                        (f) => f == props.address.toString()
                      ).length > 0
                      ? "brightness(100%)"
                      : "brightness(70%)"
                    : detectMouse
                    ? "brightness(70%)"
                    : "brightness(100%)"
                  : "",
              }}
            />
          ))}
        {!loaded &&
          [...Array(10)].map((i, x) => (
            <CardItemSkeleton key={x} size={gridSize} />
          ))}
      </SimpleGrid>
      {data.length == 0 && loaded && <EmptyItems />}
    </Container>
  );
}
